// Empax Studio content. Plain, simple language. No em dashes.

export const IMG = {
  tanya: '/tanya.jpg',
  vijay: '/vijay.jpg',
  w1: 'https://images.unsplash.com/photo-1748525938712-a065b4396ba4?q=80&w=1600',
  w2: 'https://images.unsplash.com/photo-1730917643616-3c73cc31d68a?q=80&w=1600',
  w3: 'https://images.unsplash.com/photo-1617405207593-7d0601bbdd37?q=80&w=1600',
  w4: 'https://images.unsplash.com/photo-1511317559916-56d5ddb62563?q=80&w=1600',
  w5: 'https://images.unsplash.com/photo-1567958436049-f2903793328b?q=80&w=1600',
  w6: 'https://images.unsplash.com/photo-1780304264486-c46ce6344963?q=80&w=1600',
};

export const nav = [
  { label: 'Studio', href: '#founders' },
  { label: 'How we think', href: '#discipline' },
  { label: 'Our crafts', href: '#crafts' },
  { label: 'Our work', href: '#work' },
];

export const hero = {
  eyebrow: ['Synthesising', 'Experiences'],
  sub: 'An experience design and engineering studio in Mumbai. Architecture, creativity and technology in one team, from the first conversation to the last cable on site.',
  coords: ['N \u00b7 19.0760\u00b0', 'E \u00b7 72.8777\u00b0', 'MUMBAI'],
  ticker: 'STORY \u00b7 SPACE \u00b7 SYSTEMS \u00b7 ENGINEERED',
  fig: 'FIG. 00',
};

export const gap = {
  index: 'II',
  label: 'The Gap',
  headline: ['Why good ideas sometimes lose meaning', 'before they reach the\u00a0room.'],
  body: 'Most experiences are created in parts. One team develops the idea, another designs the space, someone else works out the technology, and a fourth team has to figure out how to build it. Every handover creates another interpretation, and somewhere between the first idea and the finished experience, something changes. Sometimes a lot.',
  pull: 'The distance between what was imagined and what finally opens is the only place we work.',
  kicker:
    'We started Empax to close that distance. Keep the people who imagine the experience and the people who have to make it real in the same conversation from the beginning. Less gets lost. Better decisions get made earlier. And the finished space stays close to the reason it was created.',
};

export const founders = {
  index: 'III',
  label: 'HOW IT BEGAN',
  intro:
    'Empax started the way real things start. Two people who saw the world in different ways, but could not keep those ways apart.',
  people: [
    {
      fig: 'FIG. 01 \u00b7 TANYA',
      role: 'CO-FOUNDER \u00b7 DESIGN & EXPERIENCE SYNTHESIST',
      name: 'Tanya Jain',
      img: IMG.tanya,
      paras: [
        'Tanya is an artist at heart. Long before architecture, interfaces or experience design, there was painting, and that way of seeing still shapes everything she does.',
        'Architecture taught her to shape space. UI and UX taught her to shape journeys. Design thinking at IIT Delhi taught her to question, connect and design around people. But Tanya never saw these as separate disciplines.',
        'She moves naturally between art, space, interaction and human behaviour, thinking about how something looks, how it works, how someone moves through it and, most importantly, how it makes them feel.',
        'For her, a space is a composition. A screen is part of the journey. Technology is part of the environment. Every element belongs to something larger. That instinct to see the whole, and bring different ways of thinking together, was there long before there was a studio to give it a name.',
      ],
      quote: '\u201cWhat began as an artist\u2019s way of seeing became a way of bringing everything together.\u201d',
      note: 'She was thinking this way before there was a studio to hold it.',
    },
    {
      fig: 'FIG. 02 \u00b7 VIJAY',
      role: 'FOUNDER \u00b7 TECHNICAL & EXPERIENCE SYNTHESIST',
      name: 'Vijay Sabhlok',
      img: IMG.vijay,
      paras: [
        'Vijay has spent more than three decades understanding what technology can do to a space, and when it should quietly step back.',
        'He started on the floor, running cables, tuning systems and solving problems in real time. That taught him how spaces truly behave when technology, people, physics and pressure come together.',
        'Today, the tools are easier. Renders are instant. Looking good is the starting point, not the achievement. For Vijay, the real value is judgement: knowing what the experience needs, which technology will strengthen it, and when light, sound, media and systems should become visible or disappear completely.',
        'He thinks beyond the idea to how it will actually work: the engineering, the budget, the people, the systems and the final moment when everything comes alive. That thinking sits at the heart of Empax: not simply asking, \u2018what can we make?\u2019 but \u2018what should we make?\u2019',
      ],
      quote: '\u201cTechnology creates possibilities. Judgement decides which ones matter.\u201d',
      note: 'He thinks in systems and delivery. How the idea survives budgets, physics, and the night before the doors open.',
    },
  ],
};
